import axios from 'axios'
import { BASE_URL, API_VERSION, SCANS } from '../endpoints'

export const GET_ALL_SCANS = 'GET_ALL_SCANS'
export const ADD_SCAN = 'ADD_SCAN'
export const EDIT_SCAN = 'EDIT_SCAN'
export const DELETE_SCAN = 'DELETE_SCAN'
export const INSERT_SCANS = 'INSERT_SCANS'
export const GET_SCAN_COUNT = 'GET_SCAN_COUNT'
export const GET_SCAN_LIST = 'GET_SCAN_LIST'

export const getAllItems = (page, size, search) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${SCANS}?page=${page}&size=${size}&search=${search}&admin=true`, options)
        .then((response) => {
            dispatch({
                type: GET_ALL_SCANS,
                payload: {
                    scans: response.data.data,
                    total: response.data.data.totalElements // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};



export const addItem = (payload) => (dispatch) => {
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }
    return axios.post(BASE_URL + SCANS, payload, apiHeader)
        .then(response => {
            console.log(response.data)
            // dispatch({ type: ADD_SCAN, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const setAllItems = (payload) => (dispatch) => {
    dispatch({
        type: GET_ALL_SCANS,
        payload: {
            scans: { scans: payload },
            total: payload.length // Adjust based on API
        }
    });
}

export const insertItem = (payload) => (dispatch) => {
    dispatch({
        type: INSERT_SCANS,
        payload: {
            scans: payload,
        }
    });
}

export const deleteItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + SCANS + '/' + id, apiHeader)
        .then(response => {
            // dispatch({ type: DELETE_SCAN, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editItem = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.patch(BASE_URL + SCANS + '/' + id, payload, apiHeader)
        .then(response => {
            // dispatch({ type: EDIT_SCAN, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}


export const getScanCount = (key, query) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    const queryString = new URLSearchParams(query).toString();

    return axios.get(`${BASE_URL}${SCANS}/count?${queryString}`, options)
        .then((response) => {
            dispatch({
                type: GET_SCAN_COUNT,
                payload: {
                    key,
                    count: response.data.count // Adjust based on API
                }
            });
            return Promise.resolve(response.data.count);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const getItems = (key, query) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    const queryString = new URLSearchParams(query).toString();

    return axios.get(`${BASE_URL}${SCANS}/scans?${queryString}`, options)
        .then((response) => {
            dispatch({
                type: GET_SCAN_LIST,
                payload: {
                    key,
                    scans: response.data.scans // Adjust based on API
                }
            });
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};
